<script>

/*
    TODO:

    Options:
    - layer (from WQS)
    - size (new)
*/

import { onMount } from "svelte";
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { formatCell } from '../Utils.js';

let props = $props();

onMount(() => {
    let data = {
        "type": "FeatureCollection",
        "features": [],
    };

    let geoAttr = null;
    let geoTypes = [
        'http://www.opengis.net/ont/geosparql#wktLiteral', // used by Wikidata
		'http://www.openlinksw.com/schemas/virtrdf#Geometry' // used by LinkedGeoData.org
    ];

    props.results.results.bindings.every((node) => {
        Object.keys(node).every((key) => {
            let attr = node[key];
            if (attr.type == 'literal' && geoTypes.includes(attr.datatype)) {
                geoAttr = key;
                return false;
            }

            return true;
        });

        return geoAttr == null;
    });

    if (geoAttr) {
        props.results.results.bindings.forEach((node, index) => {
            if (node[geoAttr]) {
                let match = node[geoAttr].value.match(/\(([^ ]*) ([^)]*)\)/);
        		if (match) {
                    data.features.push({
                        type: "Feature",
                        properties: {
                            index: index,
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                parseFloat(match[1]), parseFloat(match[2])
                            ]
                        }
                    });
                }
            }
        });
    }

    const map = new maplibregl.Map({
        container: 'map',
        center: [0, 0],
        zoom: 1,
        style: {
            version: 8,
            sources: {
                osm: {
                    type: 'raster',
                    tiles: ['https://a.tile.openstreetmap.org/{z}/{x}/{y}.png'],
                    tileSize: 256,
                    attribution: '&copy; OpenStreetMap Contributors',
                    maxzoom: 19
                },
                results: {
                    type: 'geojson',
                    data: data,
                }
            },
            layers: [
                {
                    id: 'osm',
                    type: 'raster',
                    source: 'osm'
                },
                {
                    id: 'results',
                    type: 'circle',
                    source: 'results',
                    paint: {
                        'circle-color': "hsla(0,0%,0%,0.75)",
                        'circle-stroke-width': 1.5,
                        'circle-stroke-color': 'white',
                    }
                }
            ],
        },
    });

    map.on('click', 'results', (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const index = e.features[0].properties.index;

        const node = props.results.results.bindings[index];
        let description = '';
        Object.keys(node).forEach((key) => {
            description += '<p>' + formatCell(node[key]) + '</p>';
        });

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        new maplibregl.Popup().setLngLat(coordinates).setHTML(description).addTo(map);
    });

    map.on('mouseenter', 'results', () => {
        map.getCanvas().style.cursor = 'pointer';
    });

    map.on('mouseleave', 'results', () => {
        map.getCanvas().style.cursor = '';
    });
});

</script>

<style>

#map {
    height: 90vh;
}

</style>

<div id="map"></div>
